<script setup>
defineProps({
  fieldModel: Object,
  disabled: Boolean
})
</script>

<template>
  <input
    v-model.trim="fieldModel.inputValue"
    :disabled="disabled || !fieldModel.editable"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
  />
</template>
